// src/config/runeConfig.js

export interface RuneTreeConfig {
  treeImage: string;
  KEYSTONES: string[];
  SLOT1: string[];
  SLOT2: string[];
  SLOT3: string[];
}

export interface RunePathsConfig {
  [key: string]: RuneTreeConfig;
}

export type ShardPathKeys = 'ROW1' | 'ROW2' | 'ROW3';
export type ShardNames = 'Adaptive Force' | 'Attack Speed' | 'Ability Haste' | 'Bonus Movement Speed' | 'Scaling Bonus Health' | 'Bonus Health' | 'Tenacity and Slow Resist';

  export const SHARD_PATHS: Record<ShardPathKeys, ShardNames[]> = {
    ROW1: [
        'Adaptive Force',
        'Attack Speed',
        'Ability Haste'
    ],
    ROW2: [
        'Adaptive Force',
        'Bonus Movement Speed',
        'Scaling Bonus Health'
    ],
    ROW3: [
        'Bonus Health',
        'Tenacity and Slow Resist',
        'Scaling Bonus Health'
    ],
};

export const RUNE_TREES: RunePathsConfig = {
    Precision: {
      treeImage: 'https://ddragon.canisback.com/img/perk-images/Styles/7201_Precision.png',
      KEYSTONES: [
        'Press the Attack',
     //   'Lethal Tempo',
        'Fleet Footwork',
        'Conqueror',
      ],
      SLOT1: [
        'Absorb Life',
        'Triumph',
        'Presence of Mind',
      ],
      SLOT2: [
        'Legend: Alacrity',
        'Legend: Haste',
        'Legend: Bloodline',
      ],
      SLOT3: [
        'Coup de Grace',
        'Cut Down',
        'Last Stand',
      ],
    },
    Domination: {
        treeImage: 'https://ddragon.canisback.com/img/perk-images/Styles/7200_Domination.png',
        KEYSTONES: [
          'Electrocute',
        //  'Predator',
          'Dark Harvest',
          'Hail of Blades',
        ],
        SLOT1: [
          'Cheap Shot',
          'Taste of Blood',
          'Sudden Impact',
        ],
        SLOT2: [
          'Zombie Ward',
          'Ghost Poro',
          'Eyeball Collection',
        ],
        SLOT3: [
          'Treasure Hunter',
       //   'Ingenious Hunter',
          'Relentless Hunter',
          'Ultimate Hunter',
        ],
      },

      Sorcery: {
        treeImage: 'https://ddragon.canisback.com/img/perk-images/Styles/7202_Sorcery.png',
        KEYSTONES: [
          'Summon Aery',
          'Arcane Comet',
          'Phase Rush',
        ],
        SLOT1: [
          'Nullifying Orb',
          'Manaflow Band',
          'Nimbus Cloak',
        ],
        SLOT2: [
          'Transcendence',
          'Celerity',
          'Absolute Focus',
        ],
        SLOT3: [
          'Scorch',
          'Waterwalking',
          'Gathering Storm',
        ],
      },
      Resolve: {
        treeImage: 'https://ddragon.canisback.com/img/perk-images/Styles/7204_Resolve.png',
        KEYSTONES: [
          'Grasp of the Undying',
          'Aftershock',
          'Guardian',
        ],
        SLOT1: [
          'Demolish',
          'Font of Life',
          'Shield Bash',
        ],
        SLOT2: [
          'Conditioning',
          'Second Wind',
          'Bone Plating',
        ],
        SLOT3: [
          'Overgrowth',
          'Revitalize',
          'Unflinching',
        ],
      },

      Inspiration: {
        treeImage: 'https://ddragon.canisback.com/img/perk-images/Styles/7203_Whimsy.png',
        KEYSTONES: [
          'Glacial Augment',
          'Unsealed Spellbook',
          'First Strike',
        ],
        SLOT1: [
          'Hextech Flashtraption',
          'Magical Footwear',
          'Cash Back',
        ],
        SLOT2: [
          'Triple Tonic',
          'Time Warp Tonic',
          'Biscuit Delivery',
        ],
        SLOT3: [
          'Cosmic Insight',
          'Approach Velocity',
          'Jack of All Trades',
        ],
      }
  };


  export const runeToSlotMapping: Record<string, string> = {
    // Precision tree
  //  "Overheal": "slot1",
    "Absorb Life": "slot1",
    "Triumph": "slot1",
    "Presence of Mind": "slot1",
    "Legend: Alacrity": "slot2",
    "Legend: Haste": "slot2",
    "Legend: Bloodline": "slot2",
    "Coup de Grace": "slot3",
    "Cut Down": "slot3",
    "Last Stand": "slot3",
  
    // Domination tree
    "Cheap Shot": "slot1",
    "Taste of Blood": "slot1",
    "Sudden Impact": "slot1",
    "Zombie Ward": "slot2",
    "Ghost Poro": "slot2",
    "Eyeball Collection": "slot2",
    "Treasure Hunter": "slot3",
   // "Ingenious Hunter": "slot3",
    "Relentless Hunter": "slot3",
    "Ultimate Hunter": "slot3",
  
    // Sorcery tree
    "Nullifying Orb": "slot1",
    "Manaflow Band": "slot1",
    "Nimbus Cloak": "slot1",
    "Transcendence": "slot2",
    "Celerity": "slot2",
    "Absolute Focus": "slot2",
    "Scorch": "slot3",
    "Waterwalking": "slot3",
    "Gathering Storm": "slot3",
  
    // Resolve tree
    "Demolish": "slot1",
    "Font of Life": "slot1",
    "Shield Bash": "slot1",
    "Conditioning": "slot2",
    "Second Wind": "slot2",
    "Bone Plating": "slot2",
    "Overgrowth": "slot3",
    "Revitalize": "slot3",
    "Unflinching": "slot3",
  
    // Inspiration tree
    "Hextech Flashtraption": "slot1",
    "Magical Footwear": "slot1",
    "Cash Back": "slot1",
    "Triple Tonic": "slot2",
    "Time Warp Tonic": "slot2",
    "Biscuit Delivery": "slot2",
    "Cosmic Insight": "slot3",
    "Approach Velocity": "slot3",
    "Jack of All Trades": "slot3",
  };
  
  